import ListItem from './ListItem.vue';
import StageBadge from './StageBadge.vue';
import TableJobs from './TableJobs.vue';

export default {
    ListItem,
    TableJobs,
    StageBadge
}